<section class="page-wrap animated fadeIn position-relative">

  <header class="pattern-header">
    Our Story
  </header>

  <div class="content-story">

    <div class="landing-container">

      <header class="text-center mb-5">
        <span class="head-font">
          A Brief History
        </span>
        <h1 class="content-story__main-title">
          From humble beginnings...
        </h1>
      </header>

      <!-- First section -->
      <div>

        <img class="content-story__img left" src="/assets/images/landing/about/our-story/our-story.jpg"
          alt="Four men standing on a wooden bridge in front of a cornfield, dressed in casual farm attire, representing different generations of a farming family.">

        <div>

          <span class="head-font">
            1919
          </span>

          <h2 class="content-story__title mb-3">
            The Beginnings
          </h2>

          <p class="h6-regular text-justify">
            The story started in 1919 when our family purchased what would become Carlton Farms. It was a diversified
            farm for years - as they all were in that era. A few crops and a few animals worked in symbiosis. Organic
            was the only option at the time, as GMOs were unheard of, and the USDA wasn't demanding that farmers plant
            corn, soybeans & wheat from fence line to fence line.
          </p>

          <span class="head-font">
            1946
          </span>

          <h2 class="content-story__title mb-3">
            Change After World War II
          </h2>

          <p class="h6-regular mb-0 text-justify">
            In 1946, brothers Louie and Bob Carlton returned home from the Navy, where they had served in World War
            II. The family milk cow was becoming a thing of the past after the war, as many people moved into cities.
            This caused a bloom in dairies operating across the countryside, inspiring the brothers to start a dairy
            on the family farm. They would both put in long hours to get their dairy off the ground, starting with a
            herd of Brown Swiss cattle. Soon they realized the farm could only support one family. Louie and Bob
            resolved the issue by coming to an agreement - they would both apply for employment at the newly opened
            Lockheed Plant in Marietta and whoever was offered the job first would take it, leaving the other to stay
            on the farm. As fate would have it, Louie ran a successful dairy for the next 50 years while Bob began a
            career at Lockheed, eventually retiring from there.
          </p>

        </div>

      </div>

      <div class="clear"></div>

      <!-- Second section -->
      <div class="mt-3">

        <div class="right-imgs">

          <div class="position-relative">
            <img class="right-imgs__family" src="/assets/images/landing/about/our-story/family.jpg"
              alt="Portrait of a large family posing outdoors in front of a barn and silo, with adults and children standing close together, dressed in casual winter clothing" />
            <!-- <img class="right-imgs__decoration" src="/assets/images/landing/about/our-story/decoration.webp"
              alt="Gray decorative divider with a windmill design in the center and symmetrical floral patterns on each side." /> -->
          </div>
          <!--
          <img class="right-imgs__couple" src="/assets/images/landing/about/family/bobby-gayla.jpg"
            alt="Smiling couple standing in front of a wooden barn, leaning on an old wagon" /> -->

        </div>

        <div>

          <h2 class="content-story__title">
            The Rise of the Dairy Industry and Its Impact
          </h2>

          <p class="h6-regular text-justify">
            Initially, Louie delivered milk locally until creameries developed and changed his strategy. Creameries
            provided a place where dairymen could take their milk to sell it wholesale. In our mind, this was the
            beginning of a slippery slope for American agriculture. Since then, farmers would become further and further
            removed from their consumers.
          </p>

          <h2 class="content-story__title">
            Overcoming Challenges and Continuing the Legacy
          </h2>

          <p class="h6-regular text-justify">
            When Louie ran the dairy, there were some highs and lows, as there would be in any life and business. His
            wife, Mildred, became ill and eventually succumbed to cancer. Following her passing, portions of the farm
            were sold to pay the remaining medical bills. On a brighter note, their children and grandchildren were
            blessed with the ability to grow up on the farm. While many decided to pursue other ventures in adulthood,
            Louie's oldest son, Bobby, spent his life operating the family dairy. Bobby, his wife Gayla, and their
            children; Chad, Brad, and Brooke; are currently involved in the day-to-day operation of the dairy.
          </p>

        </div>

      </div>

      <div class="clear"></div>

      <div>

        <img class="content-story__img left" src="/assets/images/landing/about/our-story/cow.webp"
          alt="Group of small light pink piglets playing on a field of dry grass, with one looking directly at the camera">

        <div>

          <span class="head-font">
            2000 - 2005
          </span>

          <h2 class="content-story__title mb-3">
            A Turning Point
          </h2>

          <p class="h6-regular text-justify">
            The last 20 years saw a decrease in dairies across the southeast due to low milk prices and high feed costs.
            It would have been no different for Carlton Farms if it weren't for the hard-headedness of those involved.
            With Chad finishing his degree in Animal Science from Berry College and Brad with a Dairy Management degree
            from Utah State, the dairy needed to profit now more than ever, with more family members returning to live
            on the farm. Agri-tourism was starting to become popular for family outings in the fall. After some
            discussion, it was decided to begin providing field trips, hay rides, and a corn maze to local schools and
            weekend visitors. Though it was successful, more was needed, and in the end, selling the cows was the only
            option that made sense. That was the direction that Carlton Farms was headed until the fall of 2005.
            September of that year, a homeschool group was on a field trip at Carlton Farms, where a lady in the group
            pulled Chad to the side and asked the seemingly innocent question: <br>
            "Have ya'll ever thought about selling raw milk?"
          </p>

          <div class="clear"></div>

          <span class="head-font">
            2005 - Present
          </span>

          <h2 class="content-story__title mb-3">
            A New Beginning: Raw Milk
          </h2>

          <p class="h6-regular text-justify">
            Chad responded, "Ma'am, to my knowledge, that's illegal." The nice lady nodded, realizing Chad's ignorance
            on
            the subject of raw milk. She pulled a small piece of paper from her purse and wrote down: Weston A. Price,
            Pet
            Milk, and Cow Shares. Handing the paper to Chad, she encouraged him to research what she had written down.
            Little did she know, she changed the direction of Carlton Farms forever. The research was done, and the
            Carltons decided to jump into the "raw milk for pets" market. The first gallon of Carlton Farms raw milk for
            pets was sold on March 3rd, 2006, to the lady who started that conversation in September. Since then, the
            farm
            has welcomed the addition of several milking cows, 4000 laying hens for egg production, and numerous beef
            cows, pigs, and turkeys. Carlton Farms is now recognized as one of the premier places to patronize if you're
            looking for clean, wholesome food directly from the farmer. Products are delivered at various locations
            around
            Atlanta or can be purchased directly from the farm store.
          </p>

        </div>

      </div>

    </div>

  </div>

  <img class="sheep-img" src="/assets/images/landing/about/our-story/sheep.webp"
    alt="Two young lambs lying down next to each other on the grass, looking relaxed and facing forward">

</section>
